import structureTypes from 'common/constants/structureTypes'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import ServerPage from 'src/shared/types/server-page-interface'
import { migrateColumn } from 'tools/commands/migrate/RowColumnLayout/migrateColumn'
import { migrateRow } from 'tools/commands/migrate/RowColumnLayout/migrateRow'

export default function (page: ServerPage): [ServerPage, boolean] {
  let isChanged = false
  try {
    const entities = Object.values(page.content.entities).reduce(
      (prev, entity) => {
        if (
          entity.type === structureTypes.ROW ||
          entity.type === structureTypes.COLUMN
        ) {
          isChanged = true
        }

        return {
          // biome-ignore lint/performance/noAccumulatingSpread: deprecated file
          ...prev,
          [entity.id]:
            entity.type === structureTypes.ROW
              ? migrateRow(entity as OldEntityInterface)
              : entity.type === structureTypes.COLUMN
                ? migrateColumn(entity as OldEntityInterface)
                : entity,
        }
      },
      {},
    )
    return [
      {
        ...page,
        content: {
          ...page.content,
          entities,
        },
      },
      isChanged,
    ]
  } catch (e) {
    console.log(`--error--`, e)

    return [page, false]
  }
}
